import { splitPhoneValue, getPhoneCountryByIso } from '../phone';

// Formateadores de texto centralizados
export const toTitleCase = (text: string | null | undefined): string => {
  if (text == null) return '';

  return text
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .map((word) =>
      word
        .split('-')
        .map(
          (part) => part.charAt(0).toLocaleUpperCase('es') + part.slice(1).toLocaleLowerCase('es'),
        )
        .join('-'),
    )
    .join(' ');
};

export const capitalize = toTitleCase;

export const truncate = (
  text: string | null | undefined,
  maxLength: number = 50,
  suffix: string = '...',
): string => {
  if (!text) return '';

  if (text.length <= maxLength) return text;

  return text.substring(0, maxLength) + suffix;
};

export const slugify = (text: string | null | undefined): string => {
  if (!text) return '';

  return text
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '') // Remover caracteres especiales
    .replace(/[\s_-]+/g, '-') // Reemplazar espacios y guiones con un solo guión
    .replace(/^-+|-+$/g, ''); // Remover guiones al inicio y final
};

export const formatPhoneNumber = (phone: string | null | undefined): string => {
  if (!phone) return '';
  const { countryIso, nationalNumber } = splitPhoneValue(phone);
  const country = getPhoneCountryByIso(countryIso);
  if (!nationalNumber) return phone;
  return `${country.dialCode} ${nationalNumber}`;
};

export const formatEmail = (email: string | null | undefined): string => {
  if (!email) return '';

  return email.toLowerCase().trim();
};

export const formatInitials = (
  name: string | null | undefined,
  maxInitials: number = 2,
): string => {
  if (!name) return '';

  const words = name
    .trim()
    .split(' ')
    .filter((word) => word.length > 0);

  if (words.length === 0) return '';

  return words
    .slice(0, maxInitials)
    .map((word) => word.charAt(0).toUpperCase())
    .join('');
};

export const formatFullName = (
  firstName: string | null | undefined,
  lastName: string | null | undefined,
): string => {
  const first = firstName?.trim() || '';
  const last = lastName?.trim() || '';

  if (!first && !last) return '';

  return [first, last].filter(Boolean).join(' ');
};

export const formatAddress = (address: {
  street?: string;
  city?: string;
  state?: string;
  country?: string;
  postalCode?: string;
}): string => {
  const parts = [
    address.street,
    address.city,
    address.state,
    address.country,
    address.postalCode,
  ].filter(Boolean);

  return parts.join(', ');
};

export const formatCode = (
  code: string | number | null | undefined,
  prefix: string = '',
  padding: number = 0,
): string => {
  if (code === null || code === undefined || code === '') return '';

  const codeStr = String(code);
  const paddedCode = padding > 0 ? codeStr.padStart(padding, '0') : codeStr;

  return prefix + paddedCode;
};
